/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Faq_A4Inputs */

const en_diff_faq_a4 = /** @type {(inputs: Diff_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If no differences are found, the result will display 'No differences found.' confirming that both documents are identical.`)
};

const ko_diff_faq_a4 = /** @type {(inputs: Diff_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차이점이 발견되지 않으면 두 문서가 동일함을 확인하는 '차이점 없음' 메시지가 표시됩니다.`)
};

const ja_diff_faq_a4 = /** @type {(inputs: Diff_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差分が見つからない場合、結果に「差分なし」と表示され、両方のドキュメントが同一であることを確認できます。`)
};

/**
* | output |
* | --- |
* | "If no differences are found, the result will display 'No differences found.' confirming that both documents are identical." |
*
* @param {Diff_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_faq_a4 = /** @type {((inputs?: Diff_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_faq_a4(inputs)
	if (locale === "ko") return ko_diff_faq_a4(inputs)
	return ja_diff_faq_a4(inputs)
});